<div
  *ngIf="isLoading"
  class="flex justify-content-center p-4">
  <p-progressSpinner
    strokeWidth="4"
    [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
</div>

<form
  #formRef="ngForm"
  (ngSubmit)="save(formRef)"
  *ngIf="!isLoading">
  <div class="field flex flex-column">
    <label for="to">A<sup>*</sup></label>
    <span class="p-fluid">
      <p-autoComplete
        [(ngModel)]="selectedConfiguration.to[0].to"
        [delay]="300"
        name="to"
        (completeMethod)="searchAddressBook($event)"
        [suggestions]="suggested_addressbook_contacts"
        inputId="to"
        dataKey="id"
        [dropdown]="true"
        appendTo="body"
        dropdownIcon="pi pi-search"
        emptyMessage="Nessun contatto trovato"
        placeholder="Cerca contatto..."
        [multiple]="true">
        <ng-template
          let-contact
          pTemplate="item">
          {{ contact?.name }} {{ contact?.last_name }}
          <small> ({{ contact?.related_registry?.name }}) </small>&nbsp;
          {{ contact?.email }}
        </ng-template>
        <ng-template
          let-contact
          pTemplate="selectedItem">
          {{ contact?.name }} {{ contact?.last_name }}
          <small class="ml-1"> ({{ contact?.related_registry?.name }}) </small>&nbsp;
          {{ contact?.email }}
        </ng-template>
      </p-autoComplete>
    </span>
    <div class="flex flex-wrap gap-3 mt-2">
      <div
        class="flex align-items-center"
        *ngFor="let opt of dynamicRecipientOptions">
        <p-checkbox
          [(ngModel)]="selectedConfiguration.to[0].to_dynamic"
          [value]="opt.value"
          name="to_dynamic_{{ opt.value }}"
          inputId="to_dynamic_{{ opt.value }}"></p-checkbox>
        <label
          class="ml-2"
          for="to_dynamic_{{ opt.value }}"
          >{{ opt.label }}</label
        >
      </div>
    </div>
  </div>

  <div class="field flex flex-column">
    <label for="cc">CC</label>
    <span class="p-fluid">
      <p-autoComplete
        [(ngModel)]="selectedConfiguration.to[0].cc"
        [delay]="300"
        (completeMethod)="searchAddressBook($event)"
        [suggestions]="suggested_addressbook_contacts"
        inputId="cc"
        name="cc"
        dataKey="id"
        class="flex-grow-1"
        [dropdown]="true"
        appendTo="body"
        dropdownIcon="pi pi-search"
        emptyMessage="Nessun contatto trovato"
        placeholder="Cerca contatto..."
        [multiple]="true">
        <ng-template
          let-contact
          pTemplate="item">
          {{ contact?.name }} {{ contact?.last_name }}
          <small> ({{ contact?.related_registry?.name }}) </small>&nbsp;
          {{ contact?.email }}
        </ng-template>
        <ng-template
          let-contact
          pTemplate="selectedItem">
          {{ contact?.name }} {{ contact?.last_name }}
          <small class="ml-1"> ({{ contact?.related_registry?.name }}) </small>&nbsp;
          {{ contact?.email }}
        </ng-template>
      </p-autoComplete>
    </span>
    <div class="flex flex-wrap gap-3 mt-2">
      <div
        class="flex align-items-center"
        *ngFor="let opt of dynamicRecipientOptions">
        <p-checkbox
          [(ngModel)]="selectedConfiguration.to[0].cc_dynamic"
          [value]="opt.value"
          name="cc_dynamic_{{ opt.value }}"
          inputId="cc_dynamic_{{ opt.value }}"></p-checkbox>
        <label
          class="ml-2"
          for="cc_dynamic_{{ opt.value }}"
          >{{ opt.label }}</label
        >
      </div>
    </div>
  </div>

  <div class="field flex flex-column">
    <label for="bcc">BCC</label>
    <span class="p-fluid">
      <p-autoComplete
        [(ngModel)]="selectedConfiguration.to[0].bcc"
        [delay]="300"
        (completeMethod)="searchAddressBook($event)"
        [suggestions]="suggested_addressbook_contacts"
        inputId="bcc"
        name="bcc"
        dataKey="id"
        class="flex-grow-1"
        [dropdown]="true"
        appendTo="body"
        dropdownIcon="pi pi-search"
        emptyMessage="Nessun contatto trovato"
        placeholder="Cerca contatto..."
        [multiple]="true">
        <ng-template
          let-contact
          pTemplate="item">
          {{ contact?.name }} {{ contact?.last_name }}
          <small> ({{ contact?.related_registry?.name }}) </small>&nbsp;
          {{ contact?.email }}
        </ng-template>
        <ng-template
          let-contact
          pTemplate="selectedItem">
          {{ contact?.name }} {{ contact?.last_name }}
          <small class="ml-1"> ({{ contact?.related_registry?.name }}) </small>&nbsp;
          {{ contact?.email }}
        </ng-template>
      </p-autoComplete>
    </span>
    <div class="flex flex-wrap gap-3 mt-2">
      <div
        class="flex align-items-center"
        *ngFor="let opt of dynamicRecipientOptions">
        <p-checkbox
          [(ngModel)]="selectedConfiguration.to[0].bcc_dynamic"
          [value]="opt.value"
          name="bcc_dynamic_{{ opt.value }}"
          inputId="bcc_dynamic_{{ opt.value }}"></p-checkbox>
        <label
          class="ml-2"
          for="bcc_dynamic_{{ opt.value }}"
          >{{ opt.label }}</label
        >
      </div>
    </div>
  </div>

  <div class="field w-full mt-4">
    <label for="subject">Oggetto<sup>*</sup></label>
    <input
      pInputText
      type="text"
      required
      id="subject"
      name="subject"
      #subjectInput
      [(ngModel)]="selectedConfiguration.subject"
      (focus)="lastFocusedField = 'subject'"
      placeholder="Inserisci oggetto email"
      class="w-full" />
  </div>

  <div class="grid mt-4">
    <div class="col field">
      <label>Corpo Email<sup>*</sup></label>
      <p-editor
        [(ngModel)]="selectedConfiguration.body"
        required
        #editor
        name="body"
        (click)="lastFocusedField = 'body'"
        [style]="{ height: '150px' }"></p-editor>
    </div>

    <app-dynamic-fields-menu
      class="col-4 field self-stretch"
      [items]="replaceFields"></app-dynamic-fields-menu>
  </div>

  <div
    class="grid mt-4"
    *ngIf="attachmentsByType.length > 0">
    <div class="col field">
      <label for="attachments">Allegati</label>
      <p-multiSelect
        placeholder="Seleziona gli allegati da inviare con la mail"
        [filter]="false"
        id="attachments"
        [showClear]="true"
        name="attachments"
        optionLabel="name"
        optionValue="id"
        styleClass="w-full"
        appendTo="body"
        [displaySelectedLabel]="true"
        [emptyMessage]="'Nessun risultato trovato'"
        [options]="attachmentsByType"
        [(ngModel)]="selectedConfiguration.attachments">
      </p-multiSelect>
    </div>
  </div>

  <div class="flex flex-row justify-content-between align-items-center mt-4">
    <p-button
      *ngIf="hasConfig"
      label="Rimuovi configurazione"
      severity="danger"
      [outlined]="true"
      icon="pi pi-trash"
      type="button"
      [loading]="isDeleting"
      (onClick)="deleteConfig()"></p-button>
    <div class="ml-auto flex gap-2">
      <p-button
        label="Annulla"
        severity="secondary"
        [outlined]="true"
        type="button"
        (onClick)="dialogRef.close(null)"></p-button>
      <p-button
        label="Salva"
        [loading]="isSaving"
        type="submit"></p-button>
    </div>
  </div>
</form>
